<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>{{evaluateLanguageString(modalData.title)}}</h2>
    <ng-container *ngIf="modalData.icon">
      <div class="svg-container iconColor">
        <svg class="checkmark checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle checkmark__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark__circle checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
    </ng-container>
    <div class="confirmation-dialog-description" *ngIf="modalData.description">
      <span>{{evaluateLanguageString(modalData.description)}}</span>
    </div>
    <div class="ya-dialog-action">
      <div class="ya-button-container">
        <button mat-flat-button (click)="confirm()">
          <span>{{evaluateLanguageString(modalData.buttonText)}}</span>
        </button>
      </div>
    </div>
  </div>
</div>